import {
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  Skeleton,
  Stack,
  TextField,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import SendIcon from "@mui/icons-material/Send";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";

import boxStyles from "../../styles/boxStyles";
import { useLocation, useNavigate } from "react-router-dom";
import ApiService from "../../services/ApiService";
import { dbToDate, dbToTime } from "../../utils/dateTime";
import { LoadingButton } from "@mui/lab";

import fieldStyles from "../../styles/fieldStyles";
import DialogCustom from "../../components/DialogCustom";

// const validationSchema = yup.object({
//   upaya: yup.string("Enter your reason").required("Reason is required"),
//   perbaikan: yup.string("Enter your fix plan").required("Fix plan is required"),
// });

const CreateLFE = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const [initialValue, setInitialValue] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        await ApiService.getLkpDecision(state.data.paramLkpEncode).then(
          (res) => {
            var result = res.data.payload;

            setInitialValue(result);
          }
        );
      } catch (error) {
        console.log("error", error);
      }
    };

    fetchData();
  }, []);

  // const formik = useFormik({
  //   initialValues: {
  //     upaya: "",
  //     perbaikan: "",
  //   },
  //   validationSchema: validationSchema,
  //   onSubmit: (values) => {
  //     alert(JSON.stringify(values, null, 2));
  //   },
  // });

  const [inputFields, setInputFields] = useState({
    idLkp: 0,
    remark: "",
    uploadDocumentList: [],
  });

  const handleInputFile = async (e) => {
    // Set Loading
    setUploadDoc(true);

    // Baca File
    const files = e.target.files[0];

    // Init
    var formData = new FormData();

    // Cek ukuran file
    if (files.size > 1024 * 1024 * 10) {
      alert("Ukuran file maximum 10 Mb.");
      return;
    }

    formData.append("file", files);

    try {
      // Mengirimkan file (formData)
      await ApiService.postUploadLfe(formData)
        .then((upload) => {
          const newUpload = upload.data.payload;

          // Memasang respond
          setInputFields({
            ...inputFields,
            uploadDocumentList: [
              {
                fileZise: newUpload[0].fileZise,
                id: newUpload[0].id,
                idLfe: 0,
                isDelete: newUpload[0].isDelete,
                url: newUpload[0].url,
              },
            ],
          });
          // setMedia((old) => {
          //   return [...old, newUpload[0]];
          // });
        })
        .catch((error) => {
          console.log("error", error);
        });
    } catch (error) {
      console.log("error", error);
    }

    setUploadDoc(false);
  };

  const handleRemoveFile = (id) => {
    // let temp = inputFields.uploadDocumentList.splice(idx, 1);

    setInputFields({
      ...inputFields,
      uploadDocumentList: inputFields.uploadDocumentList.filter(
        (item) => item.id !== id
      ),
    });
  };

  // Loading Button
  const [uploadDoc, setUploadDoc] = useState(false);

  const handleSubmit = () => {
    const finalValue = {
      idLkp: initialValue.idLkp,
      remark: "",
      uploadDocumentList: inputFields.uploadDocumentList,
    };

    ApiService.postIncimanLfe(finalValue)
      .then((res) => {
        if (!res.data.isOk) {
          setFailMessage(res.data.message);
          setOpen3(true);
        } else {
          setOpen2(true);
        }
      })
      .catch((err) => {
        setOpen3(true);
      });
  };

  // Dialog Save Berhasil
  const [open2, setOpen2] = useState(false);
  const handleClose2 = () => {
    setOpen2(false);
  };
  const handleDashboard = () => {
    navigate("/hsse/incident/dashboardlkp");
  };

  // Dialog Save Gagal
  const [open3, setOpen3] = useState(false);
  const [failMessage, setFailMessage] = useState("");
  const handleClose3 = () => {
    setOpen3(false);
  };

  return (
    <div style={{ minHeight: "70vh" }}>
      <Container maxWidth={false}>
        <h2>LEARNING FROM EVENT</h2>

        {initialValue !== null ? (
          <Box
            component="form"
            noValidate
            autoComplete="off"
            // onSubmit={formik.handleSubmit}
          >
            <Box component="div" sx={boxStyles} style={{ paddingTop: "30px" }}>
              <Grid container spacing={2} style={styles.container}>
                <Grid item xs={6}>
                  <span style={styles.title}>Dibuat Oleh : </span>
                </Grid>
                <Grid item xs={6}>
                  <span style={styles.title}>Tanggal Kejadian : </span>
                  {dbToDate(initialValue.tanggalKejadian)}
                </Grid>
                <Grid item xs={6}>
                  <span style={styles.title}>Judul : </span>
                  {initialValue.judulLaporan}
                </Grid>
                <Grid item xs={6}>
                  <span style={styles.title}>Jam Kejadian : </span>
                  {dbToTime(initialValue.tanggalKejadian)}
                </Grid>
                <Grid item xs={6}>
                  <span style={styles.title}>Lokasi : </span>
                  {initialValue.lokasiName}
                </Grid>
                <Grid item xs={6}>
                  <span style={styles.title}>Kategori Insiden : </span>
                  {initialValue.kategoriInsident}
                </Grid>
                <Grid item xs={6}>
                  <span style={styles.title}>Region : </span>
                  {initialValue.regionalName}
                </Grid>
              </Grid>

              <Stack spacing={2} style={styles.container}>
                {/* <TextField
                  fullWidth
                  id="upaya"
                  name="upaya"
                  label="Upaya perbaikan yang harus dilakukan"
                  value={formik.values.upaya}
                  onChange={formik.handleChange}
                  error={formik.touched.upaya && Boolean(formik.errors.upaya)}
                  helperText={formik.touched.upaya && formik.errors.upaya}
                /> */}

                <Box component="div" sx={fieldStyles}>
                  <LoadingButton
                    variant="contained"
                    component="label"
                    loading={uploadDoc}
                    startIcon={<SendIcon />}
                    loadingPosition="start"
                  >
                    Upload Document
                    <input
                      hidden
                      multiple
                      accept=".pdf,.png,.jpg"
                      // accept=".pdf,.doc,.docx,.xlsx,.xlsm,.xlsb,.xltx,.xltm,.xls,.xlt,.xml,.xlam,.xla,.xlw,.xlr,.ppt,.pptx,image/*"
                      type="file"
                      onChange={handleInputFile}
                    />
                  </LoadingButton>
                  <span style={{ color: "red", marginLeft: "20px" }}>
                    <small>* Upload file (.pdf, .jpg) (Maximum 10 Mb)</small>
                  </span>
                  <br />
                  <br />

                  {inputFields.uploadDocumentList.map((doc, idx) => (
                    // {media.map((doc, idx) => (
                    <div style={{ maxWidth: "100%" }}>
                      <Tooltip title={doc.url} palcement="top">
                        <span style={{ opacity: "0.8" }}>
                          {idx + 1}. {doc.url.substring(35, doc.url.length)}
                        </span>
                      </Tooltip>

                      <IconButton
                        aria-label="delete"
                        color="error"
                        onClick={() => handleRemoveFile(doc.id)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </div>
                  ))}
                </Box>
              </Stack>

              <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center"
              >
                <Button
                  variant="contained"
                  sx={{ width: "150px" }}
                  // type="submit"
                  onClick={handleSubmit}
                >
                  SUBMIT
                </Button>
              </Grid>
            </Box>
          </Box>
        ) : (
          <Skeleton
            variant="rectangular"
            width={1202}
            height={428}
            animation="wave"
          />
        )}
      </Container>

      {/* Dialog Save Berhasil */}
      <DialogCustom
        open={open2}
        handleClose={handleClose2}
        title={
          <>
            Notifikasi
            {handleClose2 ? (
              <IconButton
                aria-label="close"
                onClick={handleClose2}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </>
        }
        content={<>Berhasil Membuat LKP Learning From Event</>}
        actions={
          <>
            <Button onClick={handleDashboard} autoFocus variant="contained">
              Kembali ke Dashboard
            </Button>
          </>
        }
      />

      {/* Dialog Save GAGAL */}
      <DialogCustom
        open={open3}
        handleClose={handleClose3}
        title={
          <>
            Notifikasi
            {handleClose3 ? (
              <IconButton
                aria-label="close"
                onClick={handleClose3}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </>
        }
        content={<>{failMessage}</>}
        actions={
          <>
            <Button onClick={handleClose3} autoFocus variant="contained">
              Tutup
            </Button>
          </>
        }
      />
    </div>
  );
};

const styles = {
  title: {
    fontWeight: 700,
  },
  container: {
    marginBottom: "25px",
  },
};

export default CreateLFE;
